/*
  Follie by Alice — Atelier "Su misura" (2026-11-04)
  Usato da snippets/fba-su-misura.liquid.
  - Mostra il blocco misure solo con la variante Taglia = "Su misura" (mappa JSON nello snippet).
  - Da nascosto disabilita i campi (non inviati, non bloccano la Taglia unica).
  - Valida prima di product-form.js (listener "submit" in capture su document) e blocca l'invio
    se una misura manca o e' fuori range; vale anche per il pulsante della barra sticky (form=).
  - Con "Su misura" attivo mette data-fba-su-misura su <product-info>: il CSS nasconde
    pagamento rapido, stima consegna standard e ritiro in negozio.
  Agganci al cambio variante: pub/sub Ella (variant-change), evento DOM variant:update,
  change su input[name="id"]; in piu' riallineamento al submit.
*/
(function () {
  if (window.FBA_SM_READY) return;
  window.FBA_SM_READY = true;

  var SEL = '.fba-sm';
  var has = Object.prototype.hasOwnProperty;

  function blocks() { return document.querySelectorAll(SEL); }

  function map(b) {
    if (!b._fbaMap) {
      try { b._fbaMap = JSON.parse(b.querySelector('script[data-fba-sm-map]').textContent); }
      catch (e) { b._fbaMap = {}; }
    }
    return b._fbaMap;
  }

  function fields(b) { return b.querySelectorAll('[data-fba-sm-field]'); }

  function errEl(i) {
    var id = i.id + '-err';
    return document.getElementById(id);
  }

  function setErr(i, msg) {
    var e = errEl(i);
    if (msg) {
      i.setAttribute('aria-invalid', 'true');
      if (e) { e.textContent = msg; e.hidden = false; }
    } else {
      i.removeAttribute('aria-invalid');
      if (e) { e.textContent = ''; e.hidden = true; }
    }
  }

  function setState(b, on) {
    if (b._fbaOn === on) return;
    b._fbaOn = on;
    b.hidden = !on;
    fields(b).forEach(function (i) {
      i.disabled = !on;
      if (!on) setErr(i, '');
    });
    var root = b.closest('product-info');
    if (root) root.toggleAttribute('data-fba-su-misura', on);
  }

  function applyVariant(id) {
    if (id == null || id === '') return;
    id = String(id);
    blocks().forEach(function (b) {
      var m = map(b);
      if (has.call(m, id)) setState(b, m[id] === true);
    });
  }

  function formOf(b) { return document.getElementById(b.dataset.formId); }

  function syncAll() {
    blocks().forEach(function (b) {
      var f = formOf(b);
      var inp = f && f.querySelector('input[name="id"]');
      var id = inp ? String(inp.value) : '';
      var m = map(b);
      if (id && has.call(m, id)) setState(b, m[id] === true);
      else setState(b, b.dataset.initial === 'true');
    });
  }

  function checkField(i) {
    if (i.type === 'checkbox') {
      return i.checked ? '' : 'Per procedere conferma di aver letto questa condizione.';
    }
    if (i.validity && i.validity.badInput) return 'Inserisci solo numeri, ad esempio 88.';
    var raw = String(i.value || '').trim().replace(',', '.');
    if (raw === '') return 'Inserisci questa misura in centimetri.';
    var n = Number(raw);
    var min = parseFloat(i.dataset.min);
    var max = parseFloat(i.dataset.max);
    if (!isFinite(n)) return 'Inserisci solo numeri, ad esempio 88.';
    if (n < min || n > max) return 'Controlla il valore: deve essere tra ' + min + ' e ' + max + ' cm.';
    return '';
  }

  function validate(b) {
    var first = null;
    fields(b).forEach(function (i) {
      var msg = checkField(i);
      setErr(i, msg);
      if (msg && !first) first = i;
    });
    return first;
  }

  /* Altri form di aggiunta (es. "Acquista il look" / bundle): la variante "Su misura"
     non ha i campi misure, quindi si blocca e si rimanda al blocco principale */
  function isSuMisuraId(id) {
    var found = false;
    blocks().forEach(function (b) { var m = map(b); if (m[String(id)] === true) found = true; });
    return found;
  }

  function guardOtherForm(f, e) {
    var hit = false;
    try {
      new FormData(f).forEach(function (v, k) {
        if ((k === 'id' || k === 'group_id' || /\[id\]$/.test(k)) && isSuMisuraId(v)) hit = true;
      });
    } catch (_) { return; }
    if (!hit) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    var msg = f.querySelector('.fba-sm-bundle-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'fba-sm__err fba-sm-bundle-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = "La versione su misura va aggiunta dal pulsante principale, dopo aver inserito le tue misure. Qui scegli la Taglia unica.";
      var btn = f.querySelector('[type="submit"]');
      if (btn && btn.parentNode) btn.parentNode.insertBefore(msg, btn); else f.appendChild(msg);
    }
    try { msg.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) {}
  }

  /* Validazione prima dell'add-to-cart AJAX di Ella */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    /* getAttribute: f.id restituirebbe l'input name="id" del form, non l'id del form */
    var fid = f && f.getAttribute ? f.getAttribute('id') : null;
    if (!fid) return;
    var b = null;
    blocks().forEach(function (x) { if (x.dataset.formId === fid) b = x; });
    if (!b) { guardOtherForm(f, e); return; }
    var inp = f.querySelector('input[name="id"]');
    if (inp) applyVariant(inp.value);
    if (!b._fbaOn) return;
    var bad = validate(b);
    if (!bad) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    try { bad.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (_) { bad.scrollIntoView(); }
    try { bad.focus({ preventScroll: true }); } catch (_) {}
  }, true);

  /* Errore tolto mentre si corregge, ricontrollo all'uscita dal campo */
  document.addEventListener('input', function (e) {
    var i = e.target;
    if (i && i.hasAttribute && i.hasAttribute('data-fba-sm-field') && i.getAttribute('aria-invalid') === 'true') {
      if (!checkField(i)) setErr(i, '');
    }
  });
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (i && i.type === 'checkbox' && i.hasAttribute('data-fba-sm-field') && i.checked) setErr(i, '');
  });
  document.addEventListener('focusout', function (e) {
    var i = e.target;
    if (i && i.hasAttribute && i.hasAttribute('data-fba-sm-field') && i.type !== 'checkbox' && i.value !== '') {
      setErr(i, checkField(i));
    }
  });

  function init() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (evt) {
        var v = evt && evt.data && evt.data.variant;
        if (v && v.id) applyVariant(v.id);
      });
    }
    if (typeof MainEvents !== 'undefined' && MainEvents.variantUpdate) {
      document.addEventListener(MainEvents.variantUpdate, function (e) {
        var v = e.detail && e.detail.resource;
        if (v && v.id) applyVariant(v.id);
      });
    }
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.name === 'id') applyVariant(t.value);
    }, true);
    syncAll();
  }

  window.FBA_SM_sync = syncAll;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
